import { useContext } from 'react';

// import LyocTitle from '@/components/static/LyocTitle';
import { getColor } from '@/const/color';
import { GameContext } from '@/state/contexts';
import { fourPlayerReq, seasons, threePlayerReq } from '@/util/season';
import { Player } from '@lc/interface/player/types';
import { useTutorial } from '@/hooks/useTutorial';
import { tutStep_50, tutStep_7, tutStep_8 } from '@/lyoc-common/src/const/tutorial';

const TurnIndicatorAbsolute = () => {
	const {
		numPlayers,
		// activePlayerId,
		monthTracker,
		seasonTracker,
		carbonReservoir,
		playerStateArray,
		myState,
		activePlayerId,
		stepTutorial,
		isTutorial
	}: any = useContext(GameContext);

	// const [activePlayer, setActivePlayer] = useState(null);

	// useEffect(() => {
	//   setActivePlayer(getActivePlayer(playerStateArray, activePlayerId));
	// }, [playerStateArray, activePlayerId]);

	const seasonSummitRequirements =
		numPlayers === 3 ? threePlayerReq : fourPlayerReq;


	const { tutorialCheck } = useTutorial();

	function getColor(color: string) {
		if (color === 'yellow') {
			return '#f6de9a';
		} else if (color === 'blue') {
			return '#15bedb';
		} else if (color === 'red') {
			return '#efa1ae';
		} else if (color === 'green') {
			return '#556341';
		} else if (color === 'fail') {
			return '#fb2d01';
		}

		return 'white';
	}

	function getColorSeason() {
		switch (seasonTracker) {
			case 0:
				return '#9bcb5b';
			case 1:
				return '#f5bf64';
			case 2:
				return '#b73656';
			case 3:
				return '#638fca';
			default:
				return '#fff';
		}
	}

	function getColorCarbonReservoir() {
		if (carbonReservoir < 10) {
			return <span style={{ color: '#fb2d01' }}>{carbonReservoir}</span>;
		} else if (carbonReservoir < 20) {
			return <span style={{ color: '#f7fb01' }}>{carbonReservoir}</span>;
		}
		return carbonReservoir;
	}

	return (
		<div className="meta-left">
			<div className="bg-black0">
				<p>
					Season:{' '}
					<span style={{ color: getColorSeason() }}>
						{seasons[seasonTracker]}
					</span>
				</p>
				<p>
					Energy Req:{' '}
					<span style={{ color: getColorSeason() }}>
						{seasonSummitRequirements[seasonTracker]}
					</span>
				</p>
				<p>Month: {monthTracker + 1}</p>
				{tutorialCheck(tutStep_7) && (
					<p>Carbon Reservoir: {getColorCarbonReservoir()}</p>
				)}
				<p style={{ color: getColor(myState?.color || '') }}>
					Current Donation:{' '}
					{playerStateArray &&
						playerStateArray.length > 0 &&
						myState?.donationCupArr.length}
				</p>
				{isTutorial && <p>stepTutorial: {stepTutorial}</p>}
			</div>
			{tutorialCheck(tutStep_50) &&
				<div className="bg-black0">
					{playerStateArray
						.toSorted((a: Player, b: Player) => a.playerId - b.playerId)
						.map((p: Player) => {
							return (
								<p
									style={{
										color: getColor(p.color),
									}}
									key={`turn-indicator-${p.color}`}
								>
									{p.playerId === activePlayerId ? '⭐' : null}{' '}
									{p.username} (Player {p.playerId})
								</p>
							);
						})}
				</div>
			}
		</div>
	);
};

export default TurnIndicatorAbsolute;
